import { useLocation } from 'react-use';
import { useSelector, shallowEqual } from 'react-redux';

export const pageHasStickyHeader = () => {
  const { pathname } = useLocation();
  const { nodeType, isServerSideRendering, triggerRoute } = useSelector(
    (state) => ({
      nodeType: state.node.last.node.data.pageFolderType,
      isServerSideRendering: state.renderContext.isServerSideRendering,
      triggerRoute: state['demo-common'].triggerRoute,
    }),
    shallowEqual,
  );
  const isSSR = typeof window === 'undefined' || (typeof isServerSideRendering === 'boolean' && isServerSideRendering);
  const isProductPage = nodeType === 'product';

  const isCategoriesPage = !isSSR
    ? !!document.getElementById('categoryPage') || nodeType === 'search' || nodeType === 'category'
    : false;

  return {
    hasSticky: !(isProductPage || isCategoriesPage),
    triggerRoute,
    nodeType,
    pathname,
  };
};
